var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 7c0-3.867 3.133-7 7-7s7 3.133 7 7-3.133 7-7 7-7-3.133-7-7m7.7-.7v4.2H6.3V6.3zM7 12.6A5.607 5.607 0 0 1 1.4 7c0-3.087 2.513-5.6 5.6-5.6s5.6 2.513 5.6 5.6-2.513 5.6-5.6 5.6m.7-9.1v1.4H6.3V3.5z",
    clipRule: "evenodd"
  })));
};
export default SvgInfo;